import * as React from 'react';

let token: string;

export const AuthenticityTokenInput = () => {
  token ??= $('meta[name="csrf-token"]').attr('content');

  return <input type="hidden" name="authenticity_token" value={token} />;
};
